import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import BaseModal from '../../BaseModal';
import {
  clearPerformanceModalFilters,
  setPerformanceModals,
} from '@/store/slices/components/dashboard/DashboardSlice';
import buildQuery from '@/components/Dashboard/utils/buildQuery';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import DownloadButton from '@/components/Dashboard/DashboardTables/components/DownloadButton';
import styles from '../../performanceModals.module.scss';
import buildTableQuery from '@/components/Dashboard/utils/buildTableQuery';
import useAsyncTableExcelDownload from '@/components/Dashboard/customHooks/useAsyncTableExcelDownload';
import { TABLES } from '@/components/Dashboard/constants';
import TableSearchEmptyState from '@/components/Dashboard/DashboardTables/TableSearchEmptyState';
import SearchInput from '../../SearchInput';
import { closedLeadsTypesOptions } from '../utils';
import useTrackPerformanceTable from '@/components/Dashboard/customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';
import ClosedLeadsTable from '@/components/Dashboard/DashboardTables/ClosedLeadsTable';
import { getPerformanceClosedLeadsTable } from '@/store/slices/components/dashboard/service';

export default function ClosedLeadsModal() {
  const dispatch = useDispatch();
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const { closedLeads } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );
  const {
    count,
    list,
    loading,
    sortBy,
    sortDirection,
    searchQuery,
    searchTypeFlag,
  } = closedLeads;
  const track = useTrackPerformanceTable();
  const { handleDownloadExcel: downloadExcel, isDownloading } =
    useAsyncTableExcelDownload(TABLES.CLOSED_LEADS);

  useEffect(() => {
    const fetchData = () => {
      const query = buildQuery(selectedIds);
      const tableQuery = buildTableQuery(closedLeads);

      dispatch(getPerformanceClosedLeadsTable({ query, tableQuery }));
    };

    fetchData();
  }, [sortBy, sortDirection, searchQuery, searchTypeFlag]);

  const handleDownloadExcel = () => {
    const query = buildQuery(selectedIds);
    const tableQuery = buildTableQuery(closedLeads);
    downloadExcel(query, tableQuery);
    track.closedLeads(TRACK_ELEMENT.DOWNLOAD_BUTTON);
  };

  const handleClearFilters = () => {
    const modal = 'closedLeads';
    const filters = ['searchQuery', 'searchType'];
    dispatch(clearPerformanceModalFilters({ modal, filters }));
  };

  return (
    <BaseModal
      id="closed-leads-modal"
      title={`${count} ${Trans(translations, 'ClosedContacts')}`}
      handleClose={() =>
        dispatch(
          setPerformanceModals({
            key: 'closedLeads',
            subkey: 'isOpen',
            value: false,
          })
        )
      }
    >
      <Box className={styles.modalControls}>
        <SearchInput
          modal="closedLeads"
          dropdownOptions={closedLeadsTypesOptions}
        />

        <DownloadButton
          onClick={handleDownloadExcel}
          disabled={isDownloading}
        />
      </Box>
      {searchQuery && list?.length === 0 && !loading ? (
        <TableSearchEmptyState onClearFilters={handleClearFilters} />
      ) : (
        <BaseModal.TableContainer>
          <ClosedLeadsTable />
        </BaseModal.TableContainer>
      )}
    </BaseModal>
  );
}
